import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function projectLabel(code, name) {
  if (code && name && code !== name) return `${code} - ${name}`;
  return code || name || '';
}
